import { device } from 'constants/media-query'
import styled from 'styled-components'

export const StyledLobbyContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 3px 0px 49px 0px;
  @media ${device.desktop} {
    padding: 84px 50px 91px 51px;
    justify-content: center;
    align-items: center;
  }
`

export const StyledImage = styled.img`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: none;
  padding: 100px 20px 100px 20px;
  @media ${device.desktop} {
    padding: 0;
    width: 241px;
    height: 147px;
  }
`
